<template>
  <div style="max-height: 100px">
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide v-for="(s, i) of slides" :key="i">
        <template #img>
          <b-img class="slides" center fluid :src="s.src" alt="image slot" />
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  props: {
    slides: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  computed: {
    cslides() {
      return []; //this.slides.map((s) => ({ src: require(`../assets/${s.src}`) }));
    },
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
};
</script>

<style scoped>
.carousel-indicators {
  bottom: -23px !important;
}
@media (max-width: 960px) {
  .slides {
    width: 800px;
    height: 800px;
  }
  .container {
    padding: 0;
  }
}
@media (max-width: 720px) {
  .slides {
    width: 500px;
    height: 500px;
  }
}
@media (max-width: 600px) {
  .slides {
    width: inherit;
    height: inherit;
  }
}
</style>
